import { defineLocals } from "../env/defineLocals.js";
import {} from "../env/index.js";
import { disconnectNode } from "../net/disconnectNode.js";
import { formatNode } from "../node/index.js";
import { formatParameterWithoutType, } from "../parameter/index.js";
export function disconnectNodeAndMatchParameters(env, node, parameters) {
    const halfEdges = disconnectNode(env.net, node);
    for (const [index, parameter] of parameters.entries()) {
        if (!parameter.isPrincipal) {
            const halfEdge = halfEdges[index];
            if (halfEdge === undefined) {
                throw new Error([
                    `[exposeRuleTarget] I expect a halfEdge at the index.`,
                    ``,
                    `  node: ${formatNode(env.net, node)}`,
                    `  index: ${index}`,
                    `  parameter: ${formatParameterWithoutType(parameter)}`,
                ].join("\n"));
            }
            defineLocals(env, [parameter.name], [halfEdge]);
        }
    }
}
//# sourceMappingURL=disconnectNodeAndMatchParameters.js.map